import groupBy from 'lodash/groupBy';
import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';

import { RootState } from '../../reducers';
import { getSelectedWeighbridgeTicketId } from '../../selected/selected.selector';
import { WeighbridgeTicket } from './weighbridge.types';
import { Forms, SearchFormFields } from '../../form/form.selector';
import { numericStringComapreFunction } from '../../../core/helpers/utils/utils';

export const getOpenWeighbridgeTickets = (state: RootState) => state.entities.weighbridgeTickets.openTickets;
export const getProcessedWeighbridgeTickets = (state: RootState) => state.entities.weighbridgeTickets.processedTickets;
export const getTransactionsInfoTickets = (state: RootState) => state.entities.weighbridgeTickets.transactionsInfo;

export const hasOpenTickets = createSelector(
  [getOpenWeighbridgeTickets],
  (tickets: WeighbridgeTicket[]) => tickets.length > 0,
);

export const getTicketGroupedByIngredient = createSelector(
  [getOpenWeighbridgeTickets],
  (tickets: WeighbridgeTicket[]) => {
    return groupBy(
      [...tickets].sort((ticket1, ticket2) => numericStringComapreFunction(ticket1.wbIngredient, ticket2.wbIngredient)),
      'wbIngredient',
    );
  },
);

export const getOpenWeighbridgeTicketById = createSelector(
  getOpenWeighbridgeTickets,
  (tickets: WeighbridgeTicket[]) => (id: string) => tickets.find((ticket) => ticket.id === id),
);

export const getWeighbridgeTicketsByIngredientId = createSelector(
  getTransactionsInfoTickets,
  (tickets) => (id: string) => tickets[id],
);

export const getTicketsByIngredient = createSelector(
  [getTicketGroupedByIngredient, getSelectedWeighbridgeTicketId],
  (tickets, ingredientName: string) =>
    tickets[ingredientName || '']?.sort((ticket1, ticket2) => ticket1.ticketId - ticket2.ticketId),
);

export const getProcessedTicketsFilteredBySearch = createSelector(
  [getProcessedWeighbridgeTickets, getFormValues(Forms.archiveTicketsFilterForm)],
  (tickets, filterFormValues: SearchFormFields) => {
    const filteredTickets = filterFormValues?.search
      ? tickets.filter((ticket) => ticket.wbIngredient.includes(filterFormValues.search))
      : [...tickets];
    return groupBy(
      filteredTickets.sort((ticket1, ticket2) =>
        numericStringComapreFunction(ticket1.wbIngredient, ticket2.wbIngredient),
      ),
      'wbIngredient',
    );
  },
);
